import React from 'react';
import { Link } from '../../Api/interfaces';
import './styles.css';

interface Props {
  link: Link;
  onTypeClicked?: (type: string) => void;
}

export default class LinkRow extends React.Component<Props> {
  private selectByType(type: string): void {
    if (this.props.onTypeClicked) {
      this.props.onTypeClicked(type);
    }
  }

  render(): JSX.Element {
    const { link } = this.props;
    return (
      <tr>
        <td valign="top">
          <div
            className="referencedEntity"
            onClick={() => this.selectByType(link.toEntity)}
          >
            {link.fromEntity}
          </div>
        </td>
        <td valign="top">
          <div>{link.fromField}</div>
        </td>
        <td valign="top">
          <div
            className="referencedEntity"
            onClick={() => this.selectByType(link.toEntity)}
          >
            {link.toEntity}
          </div>
        </td>
        <td valign="top">
          <div>{link.toField}</div>
        </td>
      </tr>
    );
  }
}
